.form {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.medication {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 14px;
  border: var(--outline);
  border-radius: var(--radius-control);
  background: var(--surface);
}

.removeError {
  font-size: 14px;
  font-weight: 600;
  color: var(--error);
}

.remove {
  align-self: flex-start;
  min-height: 44px;
  padding: 0;
  border: 0;
  background: none;
  font-size: 14px;
  font-weight: 700;
  color: var(--ink-2);
  text-decoration: underline;
  text-underline-offset: 3px;
  cursor: pointer;
}

.remove:disabled {
  color: var(--line);
  cursor: default;
}

.none {
  color: var(--ink-2);
}

.add {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin: 0;
  padding: 14px;
  border: 2px dashed var(--ink-3);
  border-radius: var(--radius-control);
}

.addTitle {
  padding: 0 6px;
  font-weight: 700;
}

.addFields {
  display: grid;
  grid-template-columns: minmax(0, 2fr) minmax(0, 1fr);
  gap: 10px;
}
